import { cn } from '@/lib/utils';
import type { SetupImportPreview } from '@mss_creator/shared';
import { plural } from './setup-import-messages';

export interface SetupImportSummaryProps {
  preview: SetupImportPreview;
}

const CHIP = 'rounded-full px-2 py-0 font-semibold text-caption';
const CHIP_OK = cn(CHIP, 'bg-bleu-ciel-tint text-bleu-ciel-deep');
const CHIP_WARN = cn(CHIP, 'bg-jaune-tint text-jaune-deep');
const CHIP_MUTED = cn(CHIP, 'bg-gray-100 text-gray-600');

/** Summary chips above the merged table (board 03). */
export function SetupImportSummary({ preview }: SetupImportSummaryProps) {
  const writtenCount = preview.written.length;
  const skippedCount = preview.skippedTooLong.length;
  const ignoredCount = preview.ignoredColumns.length;
  return (
    <div className="mb-3 flex flex-wrap gap-2" data-testid="setup-import-summary">
      {writtenCount === 0 ? (
        <span className={CHIP_MUTED}>Aucune cellule à écrire</span>
      ) : (
        <span className={CHIP_OK}>
          {plural(writtenCount, 'cellule écrite', 'cellules écrites')}
        </span>
      )}
      <span className={CHIP_MUTED}>
        {plural(preview.importedStepCount, 'étape importée', 'étapes importées')} sur 6
      </span>
      {skippedCount > 0 && (
        <span className={CHIP_WARN}>
          {plural(skippedCount, 'cellule non importée', 'cellules non importées')}
        </span>
      )}
      {ignoredCount > 0 && (
        <span className={CHIP_WARN}>
          {plural(ignoredCount, 'colonne ignorée', 'colonnes ignorées')}
        </span>
      )}
    </div>
  );
}
